import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "./pages/Common/Common_css/Form_css/Form_css.css";
import "./pages/Common/Common_css/Btn_css/Btn_css.css";
import "./pages/Common/Common_css/Modal_css/Modal_css.css";
import "./pages/Common/Common_css/Swiper_css/Swiper_css.css";
import "./pages/Common/Common_css/Offcanvas_css/Offcanvas_css.css";

import SplashOne from "./pages/SpashScreen/SplashOne";
import Login from "./pages/Auth/Login/Login";
import SignUp from "./pages/Auth/SignUp/SignUp";
import Forget_password from "./pages/Auth/Forget_password/Forget_password";
import Header from "./pages/Header/Header";
import Footer from "./pages/Footer/Footer";
import Home from "./pages/Home/Home";
import AppLayout from "./layout/AppLayout";
import Notifications from "./pages/Notifications/Notifications";
import Play_Now_Game from "./pages/Play_Now_Game/Play_Now_Game";
import Withdraw from "./pages/Withdraw/Withdraw";
import Deposite from "./pages/Deposite/Deposite";
import Bank_Account from "./pages/Bank_Account/Bank_Account";
import Add_Bank_Account from "./pages/Add_Bank_Account/Add_Bank_Account";
import Withdrawal_History_List from "./pages/Withdrawal_History_List/Withdrawal_History_List";
import Deposite_History_List from "./pages/Deposite/Deposite_History_List/Deposite_History_List";
import Self_Service_Center from "./pages/Self_Service_Center/Self_Service_Center";
import Activity from "./pages/Activity/Activity";
import Invitation_Bonus from "./pages/Invitation_Bonus/Invitation_Bonus";
import Invitation_Reward_Rules from "./pages/Invitation_Reward_Rules/Invitation_Reward_Rules";
import Invitation_Record from "./pages/Invitation_Record/Invitation_Record";
import Betting_Rebate from "./pages/Betting_Rebate/Betting_Rebate";
import Betting_Rebate_History from "./pages/Betting_Rebate_History/Betting_Rebate_History";
import Agency from "./pages/Agency/Agency";
import Invitation_Rules from "./pages/Invitation_Rules/Invitation_Rules";
import Account from "./pages/Account/Account";
import Subordinate_Data from "./pages/Subordinate_Data/Subordinate_Data";
import Commission_Details from "./pages/Commission_Details/Commission_Details";
import Rebate_Ratio from "./pages/Rebate_Ratio/Rebate_Ratio";
import Invite from "./pages/Invite/Invite";
import Confidentiality_Agreement from "./pages/Confidentiality_Agreement/Confidentiality_Agreement";
import Announcement from "./pages/Announcement/Announcement";
import About_Us from "./pages/About_Us/About_Us";
import Risk_Disclosure_Agreement from "./pages/Risk_Disclosure_Agreement/Risk_Disclosure_Agreement";
import Transaction_History from "./pages/Transaction_History/Transaction_History";
import Game_History from "./pages/Game_History/Game_History";
import Gift from "./pages/Gift/Gift";
import Game_Statistics from "./pages/Game_Statistics/Game_Statistics";
import Setting_Center from "./pages/Setting_Center/Setting_Center";
import Change_Login_Password from "./pages/Change_Login_Password/Change_Login_Password";
import Bind_Mailbox from "./pages/Bind_Mailbox/Bind_Mailbox";
import Feedback from "./pages/Feedback/Feedback";
import Beginner_Guide from "./pages/Beginner_Guide/Beginner_Guide";
import Payment_Method from "./pages/Payment_Method/Payment_Method";
import Add_Payment_Method from "./pages/Payment_Method/Add_Payment_Method/Add_Payment_Method";
import Bonus_Details from "./pages/Bonus_Details/Bonus_Details";
import Wheel_Cash_Out_History from "./pages/Wheel_Cash_Out_History/Wheel_Cash_Out_History";
import Invite_Wheel from "./pages/Invite_Wheel/Invite_Wheel";
import Wallet from "./pages/Wallet/Wallet";

function App() {
  const location = useLocation();

  // Routes where Header should be hidden
  const hideHeaderRoutes = [
    "/home"
  ];

  // Routes where Footer should be hidden
  const hideFooterRoutes = [
    "/",
    "/login",
    "/sign-up",
    "/forgot-password",
    "/play-now-game",
    "/withdraw",
    "/bank-account",
    "/add-bank-account",
    "/withdrawal-history",
    "/deposite",
    "/deposite-history",
    "/self-service-center",
    "/invitation-bonus",
    "/invitation-record",
    "/betting-rebate",
    "/invite-wheel"
  ];

  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <AppLayout>
      {shouldHideHeader && <Header />}

      <Routes>
        <Route path="/" element={<SplashOne />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/forgot-password" element={<Forget_password />} />
        <Route path="/home" element={<Home />} />
        <Route path="/play-now-game" element={<Play_Now_Game />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/bank-account" element={<Bank_Account />} />
        <Route path="/add-bank-account" element={<Add_Bank_Account />} />
        <Route path="/withdrawal-history" element={<Withdrawal_History_List />} />
        <Route path="/deposite" element={<Deposite />} />
        <Route path="/deposite-history" element={<Deposite_History_List />} />
        <Route path="/self-service-center" element={<Self_Service_Center />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/invitation-bonus" element={<Invitation_Bonus />} />
        <Route path="/invitation-reward-rules" element={<Invitation_Reward_Rules />} />
        <Route path="/invitation-record" element={<Invitation_Record/>} />
        <Route path="/betting-rebate" element={<Betting_Rebate/>} />
        <Route path="/betting-rebate-history" element={<Betting_Rebate_History/>} />
        <Route path="/invitation-rules" element={<Invitation_Rules/>} />
        <Route path="/promotion" element={<Agency/>} />
        <Route path="/subordinate-data" element={<Subordinate_Data/>} />
        <Route path="/invite" element={<Invite/>} />
        <Route path="/commission-details" element={<Commission_Details/>} />
        <Route path="/rebate-ratio" element={<Rebate_Ratio/>} />
        <Route path="/account" element={<Account/>} />
        <Route path="/confidentiality-agreement" element={<Confidentiality_Agreement/>} />
        <Route path="/announcement" element={<Announcement/>} />
        <Route path="/about-us" element={<About_Us/>} />
        <Route path="/confidentiality-agreement" element={<Confidentiality_Agreement/>} />
        <Route path="/risk-disclosure-agreement" element={<Risk_Disclosure_Agreement/>} />
        <Route path="/transaction-history" element={<Transaction_History/>} />
        <Route path="/game-history" element={<Game_History/>} />
        <Route path="/gift" element={<Gift/>} />
        <Route path="/game-statistics" element={<Game_Statistics/>} />
        <Route path="/setting-center" element={<Setting_Center/>} />
        <Route path="/change-password" element={<Change_Login_Password/>} />
        <Route path="/bind-mailbox" element={<Bind_Mailbox/>} />
        <Route path="/feedback" element={<Feedback/>} />
        <Route path="/beginners-guide" element={<Beginner_Guide/>} />
        <Route path="/payment-method" element={<Payment_Method/>} />
        <Route path="/add-payment-method" element={<Add_Payment_Method/>} />
        <Route path="/bonus-details" element={<Bonus_Details/>} />
        <Route path="/invite-wheel" element={<Invite_Wheel/>} />
        <Route path="/wheel-cash-out-history" element={<Wheel_Cash_Out_History/>} />
        <Route path="/wallet" element={<Wallet/>} />
      </Routes>

      {!shouldHideFooter && <Footer />}
    </AppLayout>
  );
}

export default App;
